export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const ORDER_LIST_MY_REQUEST = "ORDER_LIST_MY_REQUEST";
export const ORDER_LIST_MY_SUCCESS = "ORDER_LIST_MY_SUCCESS";
export const ORDER_LIST_MY_FAIL = "ORDER_LIST_MY_FAIL";
export const ORDER_LIST_MY_RESET = "ORDER_LIST_MY_RESET";

export const ORDER_LIST_REQUEST = "ORDER_LIST_REQUEST";
export const ORDER_LIST_SUCCESS = "ORDER_LIST_SUCCESS";
export const ORDER_LIST_FAIL = "ORDER_LIST_FAIL";

export const ORDER_DELIVER_REQUEST = "ORDER_DELIVER_REQUEST";
export const ORDER_DELIVER_SUCCESS = "ORDER_DELIVER_SUCCESS";
export const ORDER_DELIVER_FAIL = "ORDER_DELIVER_FAIL";
export const ORDER_DELIVER_RESET = "ORDER_DELIVER_RESET";

// delivery
export const ORDER_DELIVERY_LIST_REQUEST = "ORDER_DELIVERY_LIST_REQUEST";
export const ORDER_DELIVERY_LIST_SUCCESS = "ORDER_DELIVERY_LIST_SUCCESS";
export const ORDER_DELIVERY_LIST_FAIL = "ORDER_DELIVERY_LIST_FAIL";

export const ORDER_ACCEPT_REQUEST = "ORDER_ACCEPT_REQUEST";
export const ORDER_ACCEPT_SUCCESS = "ORDER_ACCEPT_SUCCESS";
export const ORDER_ACCEPT_FAIL = "ORDER_ACCEPT_FAIL";

export const ORDER_REJECT_REQUEST = "ORDER_REJECT_REQUEST";
export const ORDER_REJECT_SUCCESS = "ORDER_REJECT_SUCCESS";
export const ORDER_REJECT_FAIL = "ORDER_REJECT_FAIL";

export const ORDER_COMPLETE_REQUEST = "ORDER_COMPLETE_REQUEST";
export const ORDER_COMPLETE_SUCCESS = "ORDER_COMPLETE_SUCCESS";
export const ORDER_COMPLETE_FAIL = "ORDER_COMPLETE_FAIL";

export const ORDER_RETURN_REQUEST = "ORDER_RETURN_REQUEST";
export const ORDER_RETURN_SUCCESS = "ORDER_RETURN_SUCCESS";
export const ORDER_RETURN_FAIL = "ORDER_RETURN_FAIL";

export const ORDER_ASSIGN_REQUEST = "ORDER_ASSIGN_REQUEST";
export const ORDER_ASSIGN_SUCCESS = "ORDER_ASSIGN_SUCCESS";
export const ORDER_ASSIGN_FAIL = "ORDER_ASSIGN_FAIL";

export const INVOICE_REQUEST = "INVOICE_REQUEST";
export const INVOICE_SUCCESS = "INVOICE_SUCCESS";
export const INVOICE_FAIL = "INVOICE_FAIL";

export const INCOME_BY_CITY_REQUEST = "INCOME_BY_CITY_REQUEST";
export const INCOME_BY_CITY_SUCCESS = "INCOME_BY_CITY_SUCCESS";
export const INCOME_BY_CITY_FAIL = "INCOME_BY_CITY_FAIL";

export const TRANSACTION_LIST_REQUEST = "TRANSACTION_LIST_REQUEST";
export const TRANSACTION_LIST_SUCCESS = "TRANSACTION_LIST_SUCCESS";
export const TRANSACTION_LIST_FAIL = "TRANSACTION_LIST_FAIL";

export const STRIPE_PAYMENT_REQUEST = "const STRIPE_PAYMENT_REQUEST";
export const STRIPE_PAYMENT_SUCCESS = "STRIPE_PAYMENT_SUCCESS";
export const STRIPE_PAYMENT_FAIL = "STRIPE_PAYMENT_FAIL";

export const RAZORPAY_PAYMENT_REQUEST = "RAZORPAY_PAYMENT_REQUEST";
export const RAZORPAY_PAYMENT_SUCCESS = "RAZORPAY_PAYMENT_SUCCESS";
export const RAZORPAY_PAYMENT_FAIL = "RAZORPAY_PAYMENT_FAIL";
export const RAZORPAY_PAYMENT_RESET = "RAZORPAY_PAYMENT_RESET";

export const ORDER_UNDELIVERED_LIST_REQUEST = "ORDER_UNDELIVERED_LIST_REQUEST";
export const ORDER_UNDELIVERED_LIST_SUCCESS = "ORDER_UNDELIVERED_LIST_SUCCESS";
export const ORDER_UNDELIVERED_LIST_FAIL = "ORDER_UNDELIVERED_LIST_FAIL";

export const ORDER_STATUS_UPDATE_REQUEST = "ORDER_STATUS_UPDATE_REQUEST";
export const ORDER_STATUS_UPDATE_SUCCESS = "ORDER_STATUS_UPDATE_SUCCESS";
export const ORDER_STATUS_UPDATE_FAIL = "ORDER_STATUS_UPDATE_FAIL";

export const ORDER_STATUS_REQUEST = "ORDER_STATUS_REQUEST";
export const ORDER_STATUS_SUCCESS = "ORDER_STATUS_SUCCESS";
export const ORDER_STATUS_FAIL = "ORDER_STATUS_FAIL";
export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";
export const ORDER_STATUS_UPDATE_RESET = "ORDER_STATUS_UPDATE_RESET";

// Income by Pincode
export const INCOME_BY_PINCODE_REQUEST = "INCOME_BY_PINCODE_REQUEST";
export const INCOME_BY_PINCODE_SUCCESS = "INCOME_BY_PINCODE_SUCCESS";
export const INCOME_BY_PINCODE_FAIL = "INCOME_BY_PINCODE_FAIL";
